import { render, staticRenderFns } from "./card-faq-subheader.vue?vue&type=template&id=48d735e9&scoped=true&"
import script from "./card-faq-subheader.vue?vue&type=script&lang=js&"
export * from "./card-faq-subheader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d735e9",
  null
  
)

export default component.exports